<template>
    <!-- Loading -->
    <b-overlay :show="form.busy || loading">

        <!-- Form -->
        <form @submit.prevent="submit" novalidate="true">

            <!-- Field -->
            <b-form-group :label="__('profile.Current Password')">
                <b-form-input
                    type="password"
                    v-model="form.password_actual"
                    :class="{ 'is-invalid': form.errors.has('password_actual') }"
                ></b-form-input>
                <has-error :form="form" field="password_actual"></has-error>
            </b-form-group>

            <!-- Field -->
            <b-form-group :label="__('profile.New Password')">
                <b-form-input
                    type="password"
                    v-model="form.password"
                    :class="{ 'is-invalid': form.errors.has('password') }"
                ></b-form-input>
                <has-error :form="form" field="password"></has-error>
            </b-form-group>

            <!-- Field -->
            <b-form-group :label="__('profile.Repeat the New Password')">
                <b-form-input
                    type="password"
                    v-model="form.password_confirmation"
                    :class="{ 'is-invalid': form.errors.has('password_confirmation') }"
                ></b-form-input>
                <has-error :form="form" field="password_confirmation"></has-error>
            </b-form-group>

            <!-- Submit -->
            <b-form-group>
                <b-button type="submit" variant="primary" :disabled="form.busy">
                    {{ __('configuration.Save') }}
                </b-button>
            </b-form-group>
        </form>
    </b-overlay>
</template>

<script>
import { Form } from "vform";

export default {
    props: ['endpoint'],
    data() {
        return {
            loading: false,
            form: new Form({
                password_actual: null,
                password: null,
                password_confirmation: null,
            }),
        }
    },
    methods: {

        submit() {
            this.form.put(this.endpoint)
                .then(result => {
                    window.location.reload();
                })
        },

    }
}
</script>

<style scoped>

</style>
